import React from 'react';

import { Route } from '@react-router';
import { ClarityService } from '../microsoftClarity';

// Dedicated Clarity project for hotel booking flows. Scoped tightly to checkout +
// reservation status so the recording quota is spent on the booking + post-booking
// pages where fraud signals show up (PDP/listing/landing intentionally excluded).
const HOTEL_BOOKING_CLARITY_PROJECT_ID = 'wgc2eun3qk';

/**
 * Conditionally include external service scripts based on route
 */
export const RouteBasedServices = () => {
  return (
    <>
      {/* Admin registry + shop (admin + public) + admin room blocks + hotel PDPs */}
      <Route
        path={[
          '/:eventHandle/edit/registry',
          '/:eventHandle/edit/accommodations',
          '/shop',
          '/:eventHandle/edit/planning/hotelblock',
          '/createwedding',
          '/createbabyregistry',
          '/:eventHandle/travel',
          '/:eventHandle/accommodations/:accommodationId',
          '/stays/:stayId',
        ]}
        render={() => {
          return <ClarityService />;
        }}
      ></Route>
      {/* exact to avoid prefix-matching hotel PDP (/:eventHandle/accommodations/:accommodationId) */}
      <Route
        exact
        path="/:eventHandle/accommodations"
        render={() => {
          return <ClarityService />;
        }}
      ></Route>
      {/* exact to avoid prefix-matching reservation status (/travel/reservations/:reservationId),
          which is recorded on the dedicated hotel booking project below. */}
      <Route
        exact
        path="/travel/reservations"
        render={() => {
          return <ClarityService />;
        }}
      ></Route>
      {/* Hotel booking project: limited to checkout + reservation status to keep recording
          quota focused on the booking + post-booking flow (TRAV-3064). */}
      <Route
        path={['/travel/checkout', '/travel/reservations/:reservationId']}
        render={() => {
          return <ClarityService projectId={HOTEL_BOOKING_CLARITY_PROJECT_ID} />;
        }}
      ></Route>
    </>
  );
};
